import script from "./StepperPeleador.vue?vue&type=script&setup=true&lang=js"
export * from "./StepperPeleador.vue?vue&type=script&setup=true&lang=js"

import "./StepperPeleador.vue?vue&type=style&index=0&id=99d76276&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-99d76276"]])

export default __exports__